const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Panel de Asistencias — Monitoreo de Atenciones en Vivo",
    summary:
      "El Panel de Asistencias es la torre de control en tiempo real para supervisores y directores de atención. Permite visualizar instantáneamente qué cliente está conversando con qué asesor, qué departamentos están atendiendo en este momento exacto, cuántos tickets se encuentran pendientes de asignación y qué mensajes se acaban de recibir vía WhatsApp, todo actualizado segundo a segundo mediante WebSockets sin necesidad de recargar la página.",
  },
  sections: [
    {
      id: "monitoreo_tiempo_real",
      title: "1. Monitoreo en Tiempo Real y Actualización en Vivo",
      description:
        "Infraestructura reactiva basada en WebSockets para supervisar la operación al segundo.",
      items: [
        {
          id: "actualizacion_automatica",
          title: "Sincronización Bidireccional Automática",
          definition:
            "El panel se conecta directamente a los eventos en vivo del servidor (eventos de tickets y mensajes). Cada vez que un cliente envía un texto o un asesor responde, la tarjeta respectiva se actualiza en el acto.",
          importance:
            "Permite a los coordinadores detectar cuellos de botella y picos de tráfico en tiempo real sin saturar la base de datos con peticiones manuales.",
        },
        {
          id: "indicador_mensajes_no_leidos",
          title: "Alertas de Mensajes No Leídos",
          definition:
            "Cuando un ticket tiene mensajes pendientes de lectura por parte del agente, la hora de actualización se destaca en color verde vibrante y negrita para alertar de la espera.",
        },
      ],
    },
    {
      id: "supervision_agentes",
      title: "2. Supervisión de Agentes y Atenciones Pendientes",
      description:
        "Organización por columnas para auditar la carga laboral y la velocidad de respuesta.",
      items: [
        {
          id: "columna_pendientes",
          title: "Columna de Pendientes (Sin Asignar)",
          definition:
            "Agrupa todos los chats de clientes que acaban de escribir y están a la espera de ser atendidos por un agente humano.",
          importance:
            "Es la métrica más crítica de la mesa de ayuda. Un número elevado de pendientes indica sobrecarga o necesidad de redistribuir agentes.",
        },
        {
          id: "columnas_agentes",
          title: "Columnas Individuales por Asesor",
          definition:
            "Cada agente activo cuenta con su propia columna que totaliza el número de atenciones que tiene abiertas simultáneamente.",
          action:
            "Supervisa que ningún agente supere el límite saludable de chats concurrentes para mantener alta la calidad de respuesta.",
        },
      ],
    },
    {
      id: "identificacion_tickets",
      title: "3. Identificación Visual del Ticket y Departamentos",
      description:
        "Badges de color, conexiones y vista previa del último mensaje recibido.",
      items: [
        {
          id: "badge_departamento",
          title: "Badge de Fila o Departamento",
          definition:
            "Etiqueta con el color configurado de la fila (Ventas, Soporte, Finanzas) que indica la especialidad requerida por la consulta.",
        },
        {
          id: "badge_whatsapp",
          title: "Conexión de WhatsApp Origen",
          definition:
            "Identifica el canal o línea telefónica por donde ingresó la interacción (número comercial, línea de soporte o canal oficial).",
        },
        {
          id: "preview_ultimo_mensaje",
          title: "Vista Previa del Último Mensaje",
          definition:
            "Muestra un extracto del último texto recibido o enviado junto con la hora exacta en formato de 12 horas.",
        },
      ],
    },
    {
      id: "acciones_rapidas",
      title: "4. Acciones Rápidas y Asistencia Directa",
      description:
        "Intervención inmediata de supervisores para brindar apoyo en tickets complejos.",
      items: [
        {
          id: "boton_inspeccion",
          title: "Botón de Acceso Directo (Icono de Ojo)",
          definition:
            "Al hacer clic en el botón situado a la derecha de cualquier tarjeta de chat, el sistema redirige instantáneamente a la conversación en el módulo de tickets.",
          action:
            "Permite al supervisor leer el historial completo, enviar notas internas o reasignar el ticket a otro especialista si el caso lo amerita.",
        },
        {
          id: "indicador_sin_fila",
          title: "Identificación de Chats 'Sin Cola'",
          definition:
            "Los tickets que no tienen departamento asignado se marcan con una etiqueta gris 'SIN COLA' para priorizar su direccionamiento correcto.",
        },
      ],
    },
  ],
};
const en = {
  "header": {
    "badge": "BotMix Official Guide",
    "title": "Attendances Panel — Live Attendance Monitoring",
    "summary": "The Attendances Panel is the real-time command tower for service supervisors. Instantly monitor which customer is talking to which agent, active departments, pending tickets, and new incoming WhatsApp messages, updated second by second via WebSockets without page reload."
  },
  "sections": [
    {
      "id": "monitoreo_tiempo_real",
      "title": "1. Real-Time Monitoring and Live Updates",
      "description": "WebSocket-powered reactive infrastructure to supervise operations live.",
      "items": [
        {
          "id": "actualizacion_automatica",
          "title": "Automatic Bidirectional Sync",
          "definition": "Directly subscribes to server live events to update cards immediately when messages arrive."
        },
        {
          "id": "indicador_mensajes_no_leidos",
          "title": "Unread Message Alerts",
          "definition": "Visual counters alerting supervisors to unattended client messages."
        }
      ]
    },
    {
      "id": "tarjetas_conversacion",
      "title": "2. Conversation Cards and Action Buttons",
      "description": "Operational cards representing active chat tickets.",
      "items": [
        {
          "id": "card_contacto",
          "title": "Contact and Assigned Agent",
          "definition": "Shows avatar, customer name, WhatsApp connection, and assigned staff member."
        },
        {
          "id": "card_acciones",
          "title": "Direct Supervisor Actions",
          "definition": "Allows transferring tickets, reassigning agents, or stepping in directly."
        }
      ]
    }
  ]
};
const pt = {
  "header": {
    "badge": "Guia Oficial da BotMix",
    "title": "Painel de Assistências — Monitoramento de Atendimentos em Tempo Real",
    "summary": "O Painel de Assistências é a torre de controle ao vivo para coordenadores e supervisores. Visualize instantaneamente quais clientes estão conversando com quais atendentes, filas ativas, mensagens recebidas e tickets pendentes, com sincronização via WebSockets."
  },
  "sections": [
    {
      "id": "monitoreo_tiempo_real",
      "title": "1. Monitoramento em Tempo Real",
      "description": "Infraestrutura reativa baseada em WebSockets para supervisão operacional.",
      "items": [
        {
          "id": "actualizacion_automatica",
          "title": "Sincronização Automática",
          "definition": "Atualiza os cards de atendimento no momento em que as mensagens chegam."
        },
        {
          "id": "indicador_mensajes_no_leidos",
          "title": "Alertas de Não Lidos",
          "definition": "Destaque visual para mensagens que aguardam retorno do atendente."
        }
      ]
    },
    {
      "id": "tarjetas_conversacion",
      "title": "2. Cards de Conversa e Ações",
      "description": "Informações operacionais de cada atendimento ativo.",
      "items": [
        {
          "id": "card_contacto",
          "title": "Contato e Atendente",
          "definition": "Exibe nome, canal do WhatsApp e responsável pelo ticket."
        },
        {
          "id": "card_acciones",
          "title": "Ações Rápidas",
          "definition": "Permite transferir o ticket ou assumir o atendimento diretamente."
        }
      ]
    }
  ]
};
const fr = {
  "header": {
    "badge": "Guide Officiel BotMix",
    "title": "Panneau d'Assistance — Suivi des Échanges en Direct",
    "summary": "Le panneau d'assistance est la tour de contrôle en direct pour les superviseurs. Surveillez quel client échange avec quel agent, les files actives, les tickets en attente et les nouveaux messages WhatsApp sans recharger la page."
  },
  "sections": [
    {
      "id": "monitoreo_tiempo_real",
      "title": "1. Surveillance en Temps Réel",
      "description": "Infrastructure réactive basée sur WebSockets.",
      "items": [
        {
          "id": "actualizacion_automatica",
          "title": "Synchronisation Automatique",
          "definition": "Mise à jour instantanée des cartes de conversation."
        },
        {
          "id": "indicador_mensajes_no_leidos",
          "title": "Alertes Messages Non Lus",
          "definition": "Indicateurs visuels des échanges en attente de réponse."
        }
      ]
    },
    {
      "id": "tarjetas_conversacion",
      "title": "2. Cartes de Discussion et Actions",
      "description": "Détails opérationnels de chaque dossier en cours.",
      "items": [
        {
          "id": "card_contacto",
          "title": "Client et Conseiller",
          "definition": "Affiche le contact, la connexion et l'agent responsable."
        },
        {
          "id": "card_acciones",
          "title": "Actions de Supervision",
          "definition": "Permet de transférer ou de reprendre un échange directement."
        }
      ]
    }
  ]
};
const ar = {
  "header": {
    "badge": "دليل BotMix الرسمي",
    "title": "لوحة المساعدات — مراقبة المحادثات المباشرة",
    "summary": "لوحة المساعدات هي برج المراقبة اللحظي للمشرفين والمديرين. راقب مباشرة أي عميل يتواصل مع أي وكيل، والأقسام النشطة، والتذاكر المعلقة، والرسائل الواردة فورًا عبر WebSockets دون الحاجة للتحديث."
  },
  "sections": [
    {
      "id": "monitoreo_tiempo_real",
      "title": "1. المراقبة في الوقت الفعلي",
      "description": "بنية تفاعلية تعتمد على WebSockets لمراقبة العمليات لحظة بلحظة.",
      "items": [
        {
          "id": "actualizacion_automatica",
          "title": "التزامن التلقائي",
          "definition": "تحديث البطاقات فور إرسال أو استقبال أي رسالة جديدة."
        },
        {
          "id": "indicador_mensajes_no_leidos",
          "title": "تنبيهات الرسائل غير المقروءة",
          "definition": "مؤشرات مميزة للرسائل التي تنتظر ردًا من الوكيل."
        }
      ]
    },
    {
      "id": "tarjetas_conversacion",
      "title": "2. بطاقات المحادثة والإجراءات",
      "description": "تفاصيل تشغيلية لكل محادثة جارية.",
      "items": [
        {
          "id": "card_contacto",
          "title": "جهة الاتصال والوكيل",
          "definition": "عرض اسم العميل والقناة والوكيل المسؤول."
        },
        {
          "id": "card_acciones",
          "title": "إجراءات المشرف السريعة",
          "definition": "إمكانية تحويل التذكرة أو التدخل في المحادثة مباشرة."
        }
      ]
    }
  ]
};

export const MOMENTS_HELP_DATA = { es, en, pt, fr, ar };
